<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <h1>Staff</h1>
      </v-flex>
      <v-flex xs6 class="text-right">
        <v-btn color="accent" outlined dark :to="'/management/users/archived'">Archived</v-btn>
        <v-btn color="accent ml-2" depressed dark @click="createUserDialog = true">Add Staff</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="users"
            item-key="name"
            class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="updateDialogForUser(item)">
                mdi-square-edit-outline
              </v-icon>
              <v-icon
                class="mr-2"
                color="accent"
                @click="archiveDialogForUser(item)">
                mdi-archive
              </v-icon>
              <v-icon
                v-if="currentUser.roles[0] == 'Admin'"
                color="accent"
                @click="passwordReset(item)">
                mdi-lock-reset
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <add-user
      :showDialog="createUserDialog"
      :toggle="toggleCreate">
    </add-user>
    <update-user
      :showDialog="updateUserDialog"
      :toggle="toggleUpdate"
      :userDetails="userToUpdate"
      :userRole="userRole">
    </update-user>
    <archive-user
      :showDialog="archiveUserDialog"
      :toggle="toggleArchive"
      :user="userArchive">
    </archive-user>
    <password-reset
      :showDialog="passwordDialog"
      :toggle="togglePassword"
      :user="userToUpdate">
    </password-reset>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddUser from '@/components/users/Add'
import UpdateUser from '@/components/users/Update'
import ArchiveUser from '@/components/users/Archive'
import PasswordReset from '@/components/users/ResetPassword'
export default {
  name: 'listUsers',
  components: {
    AddUser,
    UpdateUser,
    ArchiveUser,
    PasswordReset
  },
  created () {
    this.loadAllUsers()
    this.loadRoles()
  },
  data () {
    return {
      archiveUserDialog: false,
      updateUserDialog: false,
      createUserDialog: false,
      passwordDialog: false,
      userArchive: null,
      userRole: null,
      index: null,
      userToUpdate: {}
    }
  },
  methods: {
    ...mapActions({
      loadAllUsers: 'user/loadAllUsers',
      loadRoles: 'role/loadRoles',
      clearAccount: 'account/clearAccount'
    }),
    toggleCreate () {
      this.createUserDialog = !(this.createUserDialog)
    },
    toggleUpdate () {
      this.updateUserDialog = !(this.updateUserDialog)
    },
    toggleArchive () {
      this.archiveUserDialog = !(this.archiveUserDialog)
    },
    togglePassword () {
      this.passwordDialog = !(this.passwordDialog)
    },
    archiveDialogForUser (item) {
      this.userArchive = item.user
      this.toggleArchive()
    },
    updateDialogForUser (item) {
      this.userToUpdate = item.user
      this.userRole = item.roles
      this.toggleUpdate()
    },
    passwordReset (item) {
      this.userToUpdate = item.user
      this.clearAccount()
      item.user.password = ''
      item.user.confirm = ''
      this.togglePassword()
    }
  },
  computed: {
    ...mapGetters({
      users: 'user/users',
      currentUser: 'user/currentUser',
      headers: 'user/headers',
      error: 'user/selectError'
    })
  }
}
</script>
